import { redirect, type RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { transactionsLoader } from './transactions-loader';

export const transactionsRoutes: RouteObject = {
  loader: transactionsLoader,
  children: [
    { path: '/transactions', loader: () => redirect('/transactions/transactional') },
    {
      path: '/transactions/transactional',
      lazy: lazyComponent(
        () => import('@pages/client/transactions'),
        'TransactionsTransactionalPage',
      ),
    },
    {
      path: '/transactions/financial',
      lazy: lazyComponent(
        () => import('@pages/client/transactions'),
        'TransactionsFinancialPage',
      ),
    },
  ],
};
